import styled, { css } from 'styled-components';

import responsive from 'theme/responsive';

import OccupancyPopup from './OccupancyPopup';

const StyledOccupancyPopup = styled(OccupancyPopup)`
    position: absolute;
    left: ${(props) => (props.fullWidth ? '-1px' : '-30px')};
    right: -1px;
    z-index: 500;
    background-color: ${(props) => props.theme.colours.white};
    border: 0.1rem solid ${(props) => props.theme.colours.grey};
    border-radius: ${(props) => props.theme.corners.box.inside}px;
    display: block;
    margin-top: 1rem;
    white-space: nowrap;
    bottom: -12px;
    transform: translateY(100%);
    white-space: nowrap;

    .occupancy-card {
        padding: 10px;

        ${responsive.sm(css`
            padding: 20px;
        `)}
    }

    &.single {
        width: 100%;

        .datepicker-card {
            width: 100%;
        }
        .datepicker__actions {
            .btn {
                padding-left: 0.5rem;
                padding-right: 0.5rem;
                width: 30%;
            }
        }
    }

    &:after {
        border: 11px solid transparent;
        border-bottom-color: ${(props) => props.theme.colours.white};
        border-top-width: 0;
        top: -10px;
    }

    &:before {
        border: 11px solid transparent;
        border-bottom-color: ${(props) => props.theme.colours.grey};
        border-top-width: 0;
        top: -11px;
    }

    &:before,
    :after {
        display: block;
        width: 0;
        height: 0;
        position: absolute;
        content: ' ';
        left: 76%;
        transform: translateX(-76%);
        transition: all 0.1s ease-in-out;
    }

    .arrow {
        left: 71%; !important
    }

    &.bottom .arrow {
        left: 77% !important;
    }

    .row {
        display: flex;
        justify-content: space-between;
        margin: -30px 0 20px;

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin: 0;
        }
    }

    label {
        display: block;
        max-width: 100%;
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 18px;
        color: ${(props) => props.theme.colours.grey};
    }

    .adults, .children {
        width: 60px;
    }

    .ages-container {
        width: 100%;
        margin-top: 20px;
    }

    .ages {
        width: 100%;
        display: flex;
        align-items: center;
    }

    .ages .age {
        width: 65px;
        margin: 0 5px 5px 0;
    }

    .add-room,
    .remove-room {
        cursor: pointer;
    }

    .room-number {
        label {
            margin-top: 39px !important;
        }
    }

    .form-control {
        height: 44px !important;
        display: block;
        padding: 0 12px;
        font-size: 17px;
        line-height: 1.42857143;
        color: ${(props) => props.theme.colours.grey};
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: ${(props) => props.theme.corners.full}px;
        outline: none;
    }

    .btn-row {
        margin-top: 20px;
        justify-content: space-between;
    }

    .invisible {
        visibility: hidden;
    }
`;
export default StyledOccupancyPopup;
